import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { ActivatedRoute } from "@angular/router";
import { DataserviceService } from "../../dataservice.service";
import {Router} from '@angular/router';
import Swal from 'sweetalert2';
import { ViewChild } from '@angular/core';
import { AngularFileUploaderComponent } from "angular-file-uploader";
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';








@Component({
  selector: 'app-update-detail',
  templateUrl: './update-detail.component.html',
  styleUrls: ['./update-detail.component.css']
})
export class UpdateDetailComponent implements OnInit {
height:Number;
update_id:Object;
basePath:String;
showUpdateDetail:any={
  type:'',
  title:'',
  description:'',
  posted_by:'',
  web_link:'',
  image:''
};
 nnn={year: 2018, month: 10, day: 25}
editBankDetail:Number;


  constructor(private router:Router,private route: ActivatedRoute,private dataservice:DataserviceService,private parserFormatter: NgbDateParserFormatter,private datePipe: DatePipe) { 
    this.route.queryParams.subscribe(params => {this.update_id = params.id});
    console.log(this.update_id);
  }




  afuConfig = {
    multiple: false,
    formatsAllowed: ".jpg,.png",
    maxSize: "1",
    uploadAPI:  {
      url:"http://18.224.22.40:3000/api/upload"
     
    },
    // theme: "dragNDrop",
    hideProgressBar: true,
    hideResetBtn: true,
    hideSelectBtn: false
};




@ViewChild('fileUpload1')
private fileUpload1:  AngularFileUploaderComponent;

DocUpload(val){
  this.showUpdateDetail.image=JSON.parse(val.response).filename;


  
}
naina(val){
  console.log(val);
  
}

  clickEditbtn(){
    this.editBankDetail=1;



    console.log(this.showUpdateDetail);
    


    
    this.showUpdateDetail.posted_on = this.datePipe.transform(this.showUpdateDetail.posted_on, 'yyyy-MM-dd'); 

var date =  this.datePipe.transform(this.showUpdateDetail.posted_on,'dd'); 
var year =  this.datePipe.transform(this.showUpdateDetail.posted_on,'yyyy'); 
var month = this.datePipe.transform(this.showUpdateDetail.posted_on,'MM'); 
this.showUpdateDetail.posted_on = {
  year:JSON.parse(year),
  month:JSON.parse(month),
  day:JSON.parse(date)
}
console.log(this.showUpdateDetail.posted_on);
    
      }

  ngOnInit() {
    this.basePath="http://18.224.22.40:3000/api/upload?filename="
    this.editBankDetail=0;
    var nnn = $('.header-section').innerHeight();
    var nnn1= $('.breadcrumb.breadcrumb-top').innerHeight();
    var nnn2 = $('.clearfix').innerHeight();
    this.height =innerHeight - nnn - nnn1 - nnn2 + 17;


    this.dataservice.updateDetail(this.update_id).subscribe(
      data=>{
        console.log(data);
        
this.showUpdateDetail=data;







console.log(this.showUpdateDetail);

}
    )





  }



  editUpdate(){

    this.showUpdateDetail.posted_on1 = this.parserFormatter.format(this.showUpdateDetail.posted_on);
    
console.log(this.showUpdateDetail);



    
    this.dataservice.addUpdate1(this.showUpdateDetail).subscribe(
      data=>{
        Swal("Update Saved");
        console.log(data);
        this.editBankDetail=0;
        
      }
    )
    
      }

}
